export const FACEBOOOK_APP_ID = '3075157002598474'

export const EMPTY_PHRASE_ID = 'EMPTY_PHRASE_ID'
